import { checkinApi } from '@/services/api/httpClient';

const actions = {

  async getAccessTokenByUnitId({ getters }) {
    const { unitId } = getters.getBrandUnitIdVariables;
    const url = `/payment/credit-card/access-token/${unitId}`;
    try {
      const resp = await checkinApi().get(url);
      return resp.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async creditCardProcess({ getters }, params) {
    const { unitId, brandId } = getters.getBrandUnitIdVariables;
    const url = '/payment/credit-card';
    try {
      const resp = await checkinApi().post(url, {
        ...params,
        unitId,
        brandId
      });
      return resp.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async generatePixPayment({ getters, commit }) {
    try {
      const admissionId = getters.getCurrentAdmissionState.data.id;

      const request = await checkinApi().post('/payment/pix', {
        admissionId: admissionId
      });

      const response = request.data;
      const { qrCodeImage, qrCodeString } = response;
      const pixResponseData = { image: qrCodeImage, code: qrCodeString };
      commit('SET_PIX_DATA', pixResponseData);
      return pixResponseData;
    } catch (err) {
      console.log('[generatePixPayment]: ERROR INFO ->', err);
      throw new Error(err);
    }
  },

  async getPixPaymentStatus({ getters, commit }) {
    try {
      const admissionId = getters.getCurrentAdmissionState.data.id;
      const request = await checkinApi().get(`/payment/pix/${admissionId}`);
      const response = request.data;
      return response;
    } catch (err) {
      console.log('[getPixPaymentStatus]: ERROR INFO ->', err);
      throw new Error(err);
    }
  },
  async getAuthorizerValidation({ getters }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/authorizer/validation`;
    try {
      const resp = await checkinApi().get(url);
      if (resp.data) {
        return resp.data;
      }
      return false;
    } catch (error) {
      return false;
    }
  },
  async postAuthorizationToken({ getters }, params) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/authorizer/validation`;
    try {
      const resp = await checkinApi().post(url, params);
      if (resp.data) {
        return resp.data;
      }
      return false;
    } catch (error) {
      return false;
    }
  },
  async getAmilTokenValidation({ getters, commit }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/amilTokenValidator`;
    try {
      const resp = await checkinApi().get(url);
      if (!resp.data.allTokensValidated) {
        commit('global/SET_AMIL_TOKENS_TO_VALIDATE', resp.data.tokensToValidate);
      }
      return resp.data.allTokensValidated;
    } catch (error) {
      return false;
    }
  },
  async setHealthInsuranceAuthorizedNotEligible({ getters, commit }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/healthInsuranceAuthorized/not-eligible`;
    try {
      await checkinApi().post(url);
    } catch (error) {
      return false;
    }
  },
};

export default actions;
